import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { LayoutContentWrapper } from 'components/LayoutContentWrapper/LayoutContentWrapper'

type StyledHeaderProps = {
  isScrolledDown: boolean
  separatorVisible?: boolean
}

const StyledHeader = styled.header<StyledHeaderProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 72px;
  z-index: 2;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ isScrolledDown, separatorVisible }) =>
    isScrolledDown || separatorVisible
      ? '0px 1px 0px rgba(0, 0, 0, 0.1)'
      : null};

  a {
    font-size: 0;
  }
`

const StyledLayoutContentWrapper = styled(LayoutContentWrapper)`
  height: 100%;
`

const isBrowser = typeof window !== 'undefined'

type HeaderProps = { separatorVisible?: boolean; children: React.ReactNode }

export const Header = ({ separatorVisible, children }: HeaderProps) => {
  const [scrollPosition, setScrollPosition] = useState(
    isBrowser ? window.scrollY : 0
  )

  useEffect(() => {
    function handleScroll() {
      setScrollPosition(isBrowser ? window.scrollY : 0)
    }

    if (isBrowser) {
      window.addEventListener('scroll', handleScroll)

      return () => window.removeEventListener('scroll', handleScroll)
    }
  }, [scrollPosition])

  return (
    <StyledHeader
      isScrolledDown={scrollPosition > 0}
      separatorVisible={separatorVisible}
    >
      <StyledLayoutContentWrapper>{children}</StyledLayoutContentWrapper>
    </StyledHeader>
  )
}
